"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewEmailRequestDtoToJSON = exports.PreviewEmailRequestDtoFromJSONTyped = exports.PreviewEmailRequestDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function PreviewEmailRequestDtoFromJSON(json) {
    return PreviewEmailRequestDtoFromJSONTyped(json, false);
}
exports.PreviewEmailRequestDtoFromJSON = PreviewEmailRequestDtoFromJSON;
function PreviewEmailRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
    };
}
exports.PreviewEmailRequestDtoFromJSONTyped = PreviewEmailRequestDtoFromJSONTyped;
function PreviewEmailRequestDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
exports.PreviewEmailRequestDtoToJSON = PreviewEmailRequestDtoToJSON;
